import e from "../../hooks/useWindowResize.js";
import t from "../../hooks/useSearchHighlight.js";
import n from "../../hooks/useKey.js";
import r from "../../hooks/useEsc.js";
import i from "../../hooks/useEffectOnce.js";
import a from "../../utils/classNames.js";
import o from "../clearableInput/ClearableInput.js";
import s from "../expander/ExpanderPanel.js";
import c from "./ListMenuGroup.js";
import { useEffect as l, useRef as u, useState as d } from "react";
import { debounce as f } from "es-toolkit/function";
import { isEmpty as p } from "es-toolkit/compat";
import { jsx as m, jsxs as h } from "react/jsx-runtime";
//#region src/components/listMenu/ListMenu.tsx
var g = 10, _ = 580, v = (e, t, n) => e.map((e) => ({
	...e,
	navItems: e.navItems.filter((e) => e[n].toLowerCase().includes(t.toLowerCase()))
})), y = (e) => e.find(({ navItems: e }) => !p(e)), b = (p) => {
	let { menuItems: b, focusFilter: x = !1, enableFilter: S = !1, filterPlaceholder: C, onFilterChange: w = () => {}, notFoundMessage: T, className: E = "", groupClassName: D = "", responsive: O = !0, autoClose: k = !0, filterKey: A = "key", trailingInputAddon: j, filterFn: M, ...N } = p, [P, F] = d(""), [I, L] = d(!1), [R, z] = d(!1), [B, V] = d(""), H = u(null), U = u(null), W = () => {
		if (O && U.current) {
			let [e] = U.current.getElementsByClassName("active");
			V(/* @__PURE__ */ h("div", {
				className: "display-flex align-items-center",
				children: [/* @__PURE__ */ m("span", { className: "uikit-icon icon-menu-hamburger margin-right-10" }), /* @__PURE__ */ m("span", { children: e?.innerText })]
			}));
		}
	};
	r(() => {
		S && H.current === document.activeElement && (F(""), w(""));
	});
	let G = f(() => {
		W(), L(window.innerWidth < _);
	}, g);
	l(G, []), e(G);
	let K = () => {
		H.current?.focus();
	};
	n((e) => {
		(e.metaKey || e.ctrlKey) && e.key === "k" && (e.preventDefault(), K());
	}), i(() => {
		x && K();
	}), l(W, [b]);
	let q = () => x && K(), J = (e) => {
		F(e), w(e);
	}, Y = S ? (M ?? v)(b, P, A) : b;
	t({
		ref: U,
		query: S ? P : "",
		deps: [Y]
	});
	let X = (e) => {
		let t = e.target.parentElement?.tagName.toLowerCase() === "li";
		k && t && z(!1);
	}, Z = a("form-group", "margin-bottom-5", "padding-left-15", "padding-right-15", "padding-bottom-15", "position-sticky", "top-0", "z-index-1"), Q = /* @__PURE__ */ h("div", {
		...N,
		className: `ListMenu ${E} ${P ? "filtered" : ""}`,
		ref: U,
		children: [
			S && /* @__PURE__ */ m("div", {
				className: Z,
				children: /* @__PURE__ */ h("div", {
					className: "input-group width-100pct",
					children: [
						/* @__PURE__ */ m("span", {
							className: "input-group-addon",
							children: /* @__PURE__ */ m("span", {
								className: "uikit-icon icon-search",
								"aria-hidden": "true"
							})
						}),
						/* @__PURE__ */ m(o, {
							value: P,
							inputRef: H,
							placeholder: C,
							onChange: J,
							onClear: q
						}),
						j && j
					]
				})
			}),
			!y(Y) && /* @__PURE__ */ m("div", {
				className: "padding-top-25 text-center text-color-gray",
				children: T
			}),
			Y.map((e, t) => /* @__PURE__ */ m(c, {
				className: D,
				menuGroup: e
			}, t))
		]
	});
	return O && I ? /* @__PURE__ */ m(s, {
		title: B,
		bsStyle: "default",
		open: R,
		onToggle: () => z(!R),
		unmountOnExit: !1,
		className: "shadow-default",
		children: /* @__PURE__ */ m("div", {
			onClick: X,
			children: Q
		})
	}) : Q;
};
//#endregion
export { b as default };

//# sourceMappingURL=ListMenu.js.map